// English messages returned by hubb-sms-lambda, mapped to keys in
// locales/<lng>/apiErrors.json under "messages".
// `match` is the exact message, or a RegExp with named groups for messages
// that contain values (the groups are passed to the translation).
// Order matters: the first match wins, so specific patterns come before
// general ones (e.g. every8dGetCreditFailed before every8dInvalidCredentials).
const apiErrorMessages = [
  {
    match: "Unauthorized: Invalid credentials",
    key: "unauthorizedInvalidCredentials",
  },
  { match: "Account is inactive", key: "accountInactive" },
  { match: "Account is pending activation", key: "accountPendingActivation" },
  { match: "Account has expired", key: "accountExpired" },
  { match: "Account is not active", key: "accountNotActive" },
  { match: "User not found or has been deleted", key: "userNotFoundOrDeleted" },
  { match: "Refresh token is required", key: "refreshTokenRequired" },
  { match: "Invalid or expired refresh token", key: "invalidRefreshToken" },
  { match: "No token provided", key: "noTokenProvided" },
  { match: "Invalid token", key: "invalidToken" },
  { match: "Successfully logged out", key: "loggedOut" },
  { match: "Already logged out", key: "alreadyLoggedOut" },
  { match: "Token expired, logout successful", key: "tokenExpiredLoggedOut" },
  { match: "Logout completed", key: "logoutCompleted" },
  {
    match: "Unauthorized: No user information found",
    key: "noUserInformation",
  },
  {
    match: "Unauthorized: No tenant information found",
    key: "noTenantInformation",
  },
  { match: "User not authenticated", key: "userNotAuthenticated" },
  {
    match: "Insufficient permissions to access this resource",
    key: "insufficientPermissions",
  },
  {
    match: /^Insufficient permissions\. Required roles: (?<roles>.+)$/,
    key: "insufficientPermissionsRoles",
  },
  {
    match:
      /^Insufficient permissions for this tenant\. Required roles: (?<roles>.+)$/,
    key: "insufficientPermissionsTenantRoles",
  },
  {
    match: "Tenant ID is required for this operation",
    key: "tenantIdRequiredForOperation",
  },
  { match: "Tenant ID is required", key: "tenantIdRequired" },
  { match: "Missing tenant ID", key: "missingTenantId" },
  {
    match: /^User does not belong to tenant (?<tenantId>.+)$/,
    key: "userNotInTenantId",
  },
  { match: "User does not belong to this tenant", key: "userNotInTenant" },
  { match: "Target user ID is required", key: "targetUserIdRequired" },
  {
    match:
      /^Only SUPER_ADMIN can (?<action>.+) platform administrator accounts$/,
    key: "onlySuperAdminPlatformAdmin",
  },
  { match: "Forbidden: Admin access required", key: "adminAccessRequired" },
  {
    match: "Only admins can trigger delivery status updates",
    key: "onlyAdminsTriggerDelivery",
  },
  {
    match: "Insufficient permissions to view admin statistics",
    key: "noPermissionAdminStatistics",
  },
  {
    match: "You do not have permission to view roles",
    key: "noPermissionViewRoles",
  },
  {
    match: "You don't have permission to view tenant users",
    key: "noPermissionViewTenantUsers",
  },
  {
    match: "Insufficient permissions to update tenant settings",
    key: "noPermissionUpdateTenantSettings",
  },
  {
    match: "Insufficient permissions to view tenant settings",
    key: "noPermissionViewTenantSettings",
  },
  {
    match: "Only tenant administrators can update tenant users",
    key: "onlyTenantAdminUpdateUsers",
  },
  {
    match: "Only tenant administrators can invite users",
    key: "onlyTenantAdminInvite",
  },
  {
    match:
      "Tenant administrators can only invite users with TENANT_USER or TENANT_ADMIN roles",
    key: "tenantAdminInviteRoles",
  },
  {
    match: "You can only update users within your tenant",
    key: "onlyUpdateOwnTenantUsers",
  },
  {
    match: "Cannot update platform administrator accounts",
    key: "cannotUpdatePlatformAdmin",
  },
  {
    match: "This endpoint can only update SUPER_ADMIN or ADMIN users",
    key: "onlyUpdatePlatformAdmins",
  },
  {
    match: "Platform administrators should not be associated with any tenant",
    key: "platformAdminNoTenant",
  },
  { match: "User is not associated with any tenant", key: "userNoTenant" },
  {
    match: "Bad request! Please check your input.",
    key: "badRequestCheckInput",
  },
  {
    match: "Application Error! Please contact the administrator.",
    key: "applicationError",
  },
  {
    match: "Forbidden! You do not have permission to access this resource.",
    key: "forbiddenNoPermission",
  },
  { match: "404 Resource is not found!", key: "resourceNotFound" },
  {
    match:
      "Authentication is required for this resource! Please login to continue.",
    key: "authenticationRequired",
  },
  {
    match: "Unauthorized request! Please check your permission.",
    key: "unauthorizedRequest",
  },
  {
    match: "An user with this email already exists",
    key: "userWithEmailExists",
  },
  { match: "Response format error", key: "responseFormatError" },
  { match: "Internal server error", key: "internalServerError" },
  { match: "Internal Server Error", key: "internalServerErrorTitle" },
  { match: "Unknown error", key: "unknownError" },
  { match: "Unknown error occurred", key: "unknownErrorOccurred" },
  { match: "Not Found", key: "notFound" },
  { match: "Forbidden", key: "forbidden" },
  { match: "USER_NOT_FOUND", key: "userNotFoundCode" },
  { match: "TENANT_NOT_FOUND", key: "tenantNotFoundCode" },
  { match: "Network Error", key: "networkError" },
  { match: /^timeout of (?<ms>\d+)ms exceeded$/, key: "requestTimeout" },
  {
    match: /^Request failed with status code (?<status>\d+)$/,
    key: "requestFailedStatus",
  },
  { match: "User not found", key: "userNotFound" },
  { match: /^User with ID (?<id>.+) not found$/, key: "userIdNotFound" },
  { match: "Target user not found", key: "targetUserNotFound" },
  {
    match: /^User with email (?<email>.+) already exists$/,
    key: "userEmailExists",
  },
  { match: "Email address is already in use", key: "emailInUse" },
  { match: /^Email (?<email>.+) is already in use$/, key: "emailValueInUse" },
  { match: /^Role with ID (?<id>.+) not found$/, key: "roleIdNotFound" },
  { match: /^Role (?<role>\S+) not found$/, key: "roleNameNotFound" },
  { match: "Role not found", key: "roleNotFound" },
  { match: "TENANT_USER role not found", key: "tenantUserRoleNotFound" },
  {
    match:
      "At least one field (firstName, lastName, email, or role) must be provided",
    key: "atLeastOneFieldAdmin",
  },
  {
    match:
      "At least one field (firstName, lastName, or email) must be provided",
    key: "atLeastOneFieldTenantUser",
  },
  {
    match: "At least one field must be provided for update",
    key: "atLeastOneField",
  },
  { match: "Admin user updated successfully", key: "adminUserUpdated" },
  { match: "Failed to update admin user", key: "adminUserUpdateFailed" },
  { match: "User updated successfully", key: "userUpdated" },
  { match: "Failed to update user", key: "userUpdateFailed" },
  { match: "Profile updated successfully", key: "profileUpdated" },
  { match: "Failed to update profile", key: "profileUpdateFailed" },
  { match: "User deleted successfully", key: "userDeleted" },
  { match: "Failed to delete user", key: "userDeleteFailed" },
  { match: "User blocked successfully", key: "userBlocked" },
  { match: "User unblocked successfully", key: "userUnblocked" },
  { match: "User deactivated successfully", key: "userDeactivated" },
  { match: "User activated successfully", key: "userActivated" },
  { match: "User status updated successfully", key: "userStatusUpdated" },
  { match: "Invalid status value", key: "invalidStatusValue" },
  {
    match: "Status must be ACTIVE, INACTIVE, PENDING, or EXPIRED",
    key: "statusMustBe",
  },
  { match: "User ID is required", key: "userIdRequired" },
  {
    match: "User ID is required in path parameters",
    key: "userIdRequiredPath",
  },
  {
    match: "Lock expiration time (lockUntil) is required",
    key: "lockUntilRequired",
  },
  { match: "Lock expiration must be in the future", key: "lockUntilFuture" },
  { match: "User is already inactive/locked", key: "userAlreadyLocked" },
  { match: "User account locked successfully", key: "userLocked" },
  {
    match: "User account is not currently locked/inactive",
    key: "userNotLocked",
  },
  { match: "User account unlocked successfully", key: "userUnlocked" },
  { match: "Failed to retrieve roles", key: "rolesRetrieveFailed" },
  { match: "Failed to retrieve users", key: "usersRetrieveFailed" },
  { match: "Failed to fetch tenant users", key: "tenantUsersFetchFailed" },
  {
    match: "First name, email, and roleId are required",
    key: "createUserFieldsRequired",
  },
  { match: "Request body is required", key: "requestBodyRequired" },
  {
    match: "User created successfully. Invitation email sent.",
    key: "userCreatedInvitationSent",
  },
  { match: "User created successfully", key: "userCreated" },
  {
    match: "User invited successfully. Invitation email sent.",
    key: "userInvited",
  },
  {
    match: "Tenant not found for current user",
    key: "tenantNotFoundForCurrentUser",
  },
  {
    match: "User invitation cannot be resent",
    key: "invitationCannotBeResent",
  },
  {
    match:
      /^User status is (?<status>.+)\. Only PENDING or EXPIRED users can receive invitation emails\.$/,
    key: "invitationResendStatus",
  },
  {
    match: "User does not have an authentication method configured.",
    key: "noAuthenticationMethod",
  },
  { match: "Failed to send invitation email", key: "invitationEmailFailed" },
  { match: "Invitation email resent successfully", key: "invitationResent" },
  { match: "Failed to resend user invitation", key: "invitationResendFailed" },
  { match: "Unknown email error", key: "unknownEmailError" },
  {
    match: /^Cannot impersonate user with status: (?<status>.+)$/,
    key: "impersonateUserStatus",
  },
  {
    match: "Cannot impersonate user without an active tenant",
    key: "impersonateNoActiveTenant",
  },
  { match: "Impersonation successful", key: "impersonationSuccessful" },
  { match: "Tenant not found", key: "tenantNotFound" },
  { match: /^Tenant with ID (?<id>.+) not found$/, key: "tenantIdNotFound" },
  {
    match: /^Tenant with handle (?<handle>.+) not found$/,
    key: "tenantHandleNotFound",
  },
  {
    match: "No tenant found with the provided ID",
    key: "tenantNotFoundWithId",
  },
  { match: "Tenant updated successfully", key: "tenantUpdated" },
  { match: "Failed to update tenant", key: "tenantUpdateFailed" },
  {
    match: "Tenant admin not found for this tenant",
    key: "tenantAdminNotFound",
  },
  { match: "Tenant is already active", key: "tenantAlreadyActive" },
  {
    match: "Tenant is already in ACTIVE status",
    key: "tenantAlreadyActiveStatus",
  },
  {
    match: "Cannot manually activate PENDING tenant",
    key: "cannotActivatePendingTenant",
  },
  {
    match:
      "PENDING tenants are automatically activated when tenant admin completes onboarding",
    key: "pendingTenantAutoActivated",
  },
  {
    match:
      /^Cannot activate tenant with status (?<status>.+)\. Only INACTIVE tenants can be reactivated\.$/,
    key: "cannotActivateTenantStatus",
  },
  { match: "Tenant deactivated successfully", key: "tenantDeactivated" },
  {
    match: "Tenant and admin reactivated successfully",
    key: "tenantReactivated",
  },
  {
    match: "Tenant set to pending, invitation sent to tenant admin",
    key: "tenantSetPending",
  },
  { match: "Failed to update tenant status", key: "tenantStatusUpdateFailed" },
  { match: "Failed to fetch tenant details", key: "tenantDetailsFetchFailed" },
  {
    match: "A tenant with similar information already exists",
    key: "tenantSimilarExists",
  },
  { match: "Failed to create tenant", key: "tenantCreateFailed" },
  {
    match:
      "Tenant name must be at least 3 characters long to generate a valid identifier.",
    key: "tenantNameTooShort",
  },
  {
    match:
      "Unable to generate a unique identifier for this tenant name. Please contact support.",
    key: "tenantHandleGenerateFailed",
  },
  {
    match: "An onboarding record with this email already exists",
    key: "onboardingEmailExists",
  },
  {
    match: "Record already exist, Please contact your administrator",
    key: "recordAlreadyExist",
  },
  { match: "ID is required in path parameters", key: "idRequiredPath" },
  { match: "User record not found.", key: "userRecordNotFound" },
  {
    match:
      "This tenant has no pending or expired users to resend invitations to. All users may have already been activated.",
    key: "noPendingUsersToResend",
  },
  {
    match: "No onboarding record or pending users found for the provided ID.",
    key: "noOnboardingOrPendingUsers",
  },
  {
    match: "Failed to resend onboarding invitation",
    key: "onboardingResendFailed",
  },
  { match: "Onboarding invitation not found", key: "onboardingNotFound" },
  {
    match: "Failed to cancel onboarding invitation",
    key: "onboardingCancelFailed",
  },
  { match: "Failed to get onboardings", key: "onboardingsFetchFailed" },
  {
    match: "Invalid or expired onboarding token",
    key: "onboardingTokenInvalid",
  },
  {
    match: "Onboarding invitation has already been used",
    key: "onboardingAlreadyUsed",
  },
  { match: "Onboarding invitation has expired", key: "onboardingExpired" },
  {
    match: "Failed to create and send onboarding invitation",
    key: "onboardingCreateFailed",
  },
  {
    match: /^No onboarding record found for email: (?<email>.+)$/,
    key: "onboardingNotFoundForEmail",
  },
  { match: "Failed to cancel onboarding", key: "onboardingCancelFailedShort" },
  { match: "Invalid or expired invitation link", key: "invitationLinkInvalid" },
  {
    match:
      "This account has been deactivated. Please contact your administrator.",
    key: "accountDeactivatedContactAdmin",
  },
  {
    match:
      "This tenant has been deactivated. Please contact your administrator.",
    key: "tenantDeactivatedContactAdmin",
  },
  {
    match: "This user has been deactivated. Please contact your administrator.",
    key: "userDeactivatedContactAdmin",
  },
  {
    match:
      "This invitation has been cancelled. Please contact your administrator for a new invitation.",
    key: "invitationCancelled",
  },
  {
    match: "This invitation has already been completed.",
    key: "invitationAlreadyCompleted",
  },
  {
    match: "Invitation link has expired. Please contact your administrator",
    key: "invitationLinkExpiredShort",
  },
  {
    match:
      "This invitation link has expired. Please contact your administrator for a new invitation.",
    key: "invitationLinkExpired",
  },
  {
    match: "This account has already been activated. Please log in instead.",
    key: "accountAlreadyActivated",
  },
  {
    match: "Account activated successfully! You can now log in.",
    key: "accountActivated",
  },
  { match: "Failed to activate account", key: "accountActivateFailed" },
  { match: "Valid invitation token", key: "validInvitationToken" },
  { match: "Valid onboarding invitation", key: "validOnboardingInvitation" },
  {
    match: "This invitation has already been used or is invalid.",
    key: "invitationUsedOrInvalid",
  },
  {
    match: "All fields (token, email, password) are required.",
    key: "signupFieldsRequired",
  },
  { match: "Invalid email format.", key: "invalidEmailFormat" },
  {
    match: "Invalid invitation link/token used.",
    key: "invitationTokenInvalid",
  },
  {
    match: "You have to use the email address you were invited with",
    key: "useInvitedEmail",
  },
  {
    match:
      "Unable to create tenant. A tenant with this name already exists. Please contact your administrator.",
    key: "signupTenantNameExists",
  },
  {
    match:
      "Unable to create tenant after multiple attempts. Please contact support.",
    key: "signupTenantCreateRetryFailed",
  },
  {
    match:
      "An account with this email already exists and is not pending activation.",
    key: "signupAccountExistsNotPending",
  },
  {
    match:
      "An unexpected error occurred during signup. Please contact support.",
    key: "signupUnexpectedError",
  },
  {
    match:
      "A tenant with this name already exists. Please contact your administrator.",
    key: "signupTenantExists",
  },
  {
    match:
      "An account with this email already exists. Please use a different email.",
    key: "signupEmailExists",
  },
  {
    match:
      "This information is already in use. Please contact your administrator.",
    key: "signupInfoInUse",
  },
  {
    match:
      "If your email is registered, you will receive a password reset link",
    key: "passwordResetLinkSent",
  },
  {
    match: "Invalid or expired password reset token",
    key: "passwordResetTokenInvalid",
  },
  {
    match: "Password reset token not found",
    key: "passwordResetTokenNotFound",
  },
  {
    match: "Password reset token has expired",
    key: "passwordResetTokenExpired",
  },
  { match: "Password has been reset successfully", key: "passwordReset" },
  { match: "Authentication method not found", key: "authMethodNotFound" },
  { match: "Current password is incorrect", key: "currentPasswordIncorrect" },
  {
    match:
      "Invalid file type. Only JPEG, PNG, GIF, and WEBP images are allowed.",
    key: "invalidFileType",
  },
  { match: "Failed to generate upload URL", key: "uploadUrlFailed" },
  { match: "No tenant found for this user", key: "noTenantForUser" },
  {
    match: "Tenant settings updated successfully",
    key: "tenantSettingsUpdated",
  },
  {
    match: "Failed to update tenant settings",
    key: "tenantSettingsUpdateFailed",
  },
  {
    match: "Failed to retrieve tenant settings",
    key: "tenantSettingsFetchFailed",
  },
  {
    match: "Internal server error while retrieving SMS logs",
    key: "smsLogsFetchError",
  },
  {
    match: "Internal server error while retrieving SMS log",
    key: "smsLogFetchError",
  },
  { match: "Invalid date format provided", key: "invalidDateFormat" },
  { match: "Database connection error", key: "databaseConnectionError" },
  { match: "SMS log not found", key: "smsLogNotFound" },
  { match: "Failed to get SMS statistics", key: "smsStatisticsFailed" },
  {
    match: "Failed to get admin SMS statistics",
    key: "adminSmsStatisticsFailed",
  },
  { match: "No pending SMS logs to process", key: "noPendingSmsLogs" },
  {
    match: /^Successfully processed (?<count>\d+) SMS logs$/,
    key: "smsLogsProcessed",
  },
  {
    match: "Failed to update delivery status",
    key: "deliveryStatusUpdateFailed",
  },
  {
    match: "Delivery report not yet received",
    key: "deliveryReportNotReceived",
  },
  {
    match: /^Unknown DR status code: (?<code>.+)$/,
    key: "unknownDrStatusCode",
  },
  { match: /^DR status (?<code>.+)$/, key: "drStatusCode" },
  {
    match: "Account and password are required",
    key: "every8dCredentialsRequired",
  },
  {
    match:
      /^Invalid Every8D credentials: EVERY8D GetCredit failed: (?<reason>.*?) \(raw: (?<raw>.*)\)$/,
    key: "every8dGetCreditFailed",
  },
  {
    match: /^Invalid Every8D credentials: (?<reason>.+)$/,
    key: "every8dInvalidCredentials",
  },
  {
    match:
      "Failed to validate Every8D credentials. Please check your account and password.",
    key: "every8dValidateFailed",
  },
  { match: "Authentication failed", key: "authenticationFailed" },
  { match: "HubSpot not connected to this tenant", key: "hubspotNotConnected" },
  { match: "HubSpot connection is invalid", key: "hubspotConnectionInvalid" },
  {
    match: "HubSpot connection is active and valid",
    key: "hubspotConnectionValid",
  },
  {
    match: /^HubSpot portal already connected to tenant (?<tenantName>.+)$/,
    key: "hubspotPortalAlreadyConnected",
  },
  { match: "Tenant Handle is required", key: "tenantHandleRequired" },
  {
    match:
      "⚠️ Save this API key now! It will not be shown again. Use it as: Bearer tenantHandle:apiKey",
    key: "apiKeySaveNow",
  },
  {
    match: "API key is masked for security. Generate a new one if needed.",
    key: "apiKeyMasked",
  },
  { match: "Generate an API key first", key: "apiKeyGenerateFirst" },
  { match: "No API key generated", key: "noApiKeyGenerated" },
  { match: "Handle already exists", key: "handleAlreadyExists" },
];

export default apiErrorMessages;
